import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M19.008 6.642l-1.62-.515a.514.514 0 00-.604.193l-.926 1.504a.321.321 0 01-.411.116L9.546 5.034a3.857 3.857 0 00-5.542 1.968 1.041 1.041 0 00.694 1.285l4.089 1.286a.656.656 0 01.424.437l.99 3.523a.54.54 0 00.373.373l1.813.553a.578.578 0 00.746-.643l-.54-2.443a.308.308 0 01.103-.309.295.295 0 01.308-.064l3.664 1.183a1.029 1.029 0 001.286-.63l1.376-4.269a.514.514 0 00-.322-.642zM20.036 19.602H3.964a.964.964 0 010-1.928h16.072a.964.964 0 110 1.928z",
      fill: "#333"
    }
  )
);
export {
  l as default
};
